import { semanticSubApplication } from '@talend/data-quality-semantic-ee';
import { datasetSubApplication } from '@talend/dataset';
import { useFlags } from '@talend/feature-flipping';
import { ruleSubApplication } from '@talend/rule-core';

import { FEATURE_FLAGS } from '../../constants';
import { cadSubApplication } from '../../modules/CAD';
import { SidePanelEntries, SubApp } from '../../types/sub-app-system';
import { getSidePanelEntries } from '../SidePanel/SidePanel.utils';

const defaultSubApplications: SubApp[] = [
	datasetSubApplication,
	semanticSubApplication,
	cadSubApplication,
];

export const useSidePanelEntries = (): SidePanelEntries => {
	const flags = useFlags();
	const subApplications: SubApp[] = [...defaultSubApplications];

	if (flags[FEATURE_FLAGS.TDC_6383_TRR_IN_INVENTORY_ENABLED]) {
		// @ts-ignore
		subApplications.push(ruleSubApplication);
	}

	return getSidePanelEntries(subApplications);
};
